export const getHashFromObject = async (payload: object) => {
  const enc = new TextEncoder();
  const algorithm = { name: "HMAC", hash: "SHA-256" };
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode("12345"),
    algorithm,
    false,
    ["sign", "verify"]
  );
  const hash = await crypto.subtle.sign(
    algorithm.name,
    key,
    enc.encode(JSON.stringify(payload))
  );
  return Array.from(new Uint8Array(hash))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
};
